import m from "mithril";

class Notifier {
    constructor() {
        this.show = false;
        this.message = "";
        this.warning = false;
    }

    showNotify = (message, warning) => {
        this.show = true;
        this.message = message;
        this.warning = warning;
        m.redraw();

        setTimeout(() => {
            this.show = false;
            this.message = "";
            this.warning = false;
            m.redraw();
        }, 5000);

        return m.redraw();
    };

    closeNotify = () => {
        this.show = false;
        this.message = "";
        this.warning = false;
        m.redraw();
    };
}

export default new Notifier();
